export default {
  smScreenWidth: 1440,
};
